import { cn } from "@/lib/utils";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface AuthLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}

export function AuthLayout({
  title,
  description,
  children,
  className,
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold font-ocr text-gray-900 tracking-tight mb-2">
            timing:tower
          </h1>
        </div>

        <div className={cn("flex flex-col gap-6", className)}>
          <Card className="border-gray-200 shadow-sm bg-white">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-bold text-gray-900 tracking-tight">
                {title}
              </CardTitle>
              <CardDescription className="text-gray-600 font-medium">
                {description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              {children}
            </CardContent>
          </Card>

          {/* Footer */}
          <div className="text-center text-xs text-gray-400">
            © 2025 Timing Tower
          </div>
        </div>
      </div>
    </div>
  );
}